export const RneIconComponent = ({
  size = 32,
  fillColor = '#FFFFFF00',
  strokeColor = '#454545',
  strokeWidth = 2,
  style
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect width="32" height="32" rx="16" fill={fillColor} />
    <g transform="translate(7, 6) scale(0.75)">
      <path stroke={strokeColor} stroke-linecap="round" stroke-linejoin="round" stroke-width={strokeWidth} d="M14 3v4a1 1 0 0 0 1 1h4"/>
      <path stroke={strokeColor} stroke-linecap="round" stroke-linejoin="round" stroke-width={strokeWidth} d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z"/>
      <path stroke={strokeColor} stroke-linecap="round" stroke-linejoin="round" stroke-width={strokeWidth} d="m9 15l2 2l4-4"/>
   </g>
    </svg>
);